// src/components/Layout.js
import React from 'react';
import Sidebar from './Sidebar';
import ViewerContainer from './ViewerContainer';
import '../styles/global.css';

const Layout = () => {
  return (
    <div style={{ height: '100vh', overflow: 'hidden' }}>
      <Sidebar />
      <ViewerContainer />
    </div>
  );
};

export default Layout;